import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { NotificationProvider } from './contexts/notification-context';
import Layout from './components/layout/index';
import { AuthProvider } from './contexts/auth-context';
import PrivateRoute from './components/private-route/index';
import { PERFIS } from './constants/perfis/index';

// Páginas
import Agendamento from './pages/agendamentos/index';
import Agendar from './pages/agendar-salas/index';
import CadastroProfissionais from './pages/cadastro-profissionais/index';
import CadastroPacientes from './pages/cadastro-pacientes/index';
import MinhaAgenda from './pages/minha-agenda/index';
import Login from './pages/login/index';
import AcessoRestrito from './pages/acesso-restrito/index';
import Fechamento from './pages/fechamento/index';
import RedefinicaoSenha from './pages/redefinicao-senha/index';
import EsqueciSenha from './pages/esqueci-senha/index';
import Home from './pages/home/index';
import AgendarPacientes from './pages/agendar-pacientes';
import ProfissionalAgenda from './pages/profissionais-agenda/index';
import CadastrarUsuario from './pages/usuario';
import ListarUsuarios from './pages/usuario/list';
import ListarProfissionais from './pages/cadastro-profissionais/list';
import ListarPacientes from './pages/cadastro-pacientes/list';
import ConfiguracaoServicos from './pages/configuracao-servicos';
import ListarServicos from './pages/servicos/list';
import CadastrarServico from './pages/servicos';

const App = () => {
  return (
    <AuthProvider>
      <NotificationProvider>
        <Router>
          <Layout>
            <Routes>
              {/* Rotas Públicas */}
              <Route path="/login" element={<Login />} />
              <Route path="/acesso-restrito" element={<AcessoRestrito />} />
              <Route path="/redefinicao-senha" element={<RedefinicaoSenha />} />
              <Route path="/esqueci-senha" element={<EsqueciSenha />} />

              {/* Rotas Privadas */}
              <Route
                path="/"
                element={
                  <PrivateRoute allowedProfiles={[PERFIS.ADMINISTRADOR, PERFIS.AGENDAMENTO, PERFIS.PROFISSIONAL]}>
                    <Home />
                  </PrivateRoute>
                }
              />
              <Route
                path="/agendar-pacientes"
                element={
                  <PrivateRoute allowedProfiles={[PERFIS.ADMINISTRADOR, PERFIS.AGENDAMENTO]}>
                    <AgendarPacientes />
                  </PrivateRoute>
                }
              />
               <Route
                path="/"
                element={
                  <PrivateRoute allowedProfiles={[PERFIS.ADMINISTRADOR, PERFIS.AGENDAMENTO, PERFIS.PROFISSIONAL]}>
                    <Agendamento />
                  </PrivateRoute>
                }
              />
              <Route
                path="/agendar-salas"
                element={
                  <PrivateRoute allowedProfiles={[PERFIS.ADMINISTRADOR, PERFIS.AGENDAMENTO]}>
                    <Agendar />
                  </PrivateRoute>
                }
              />
              <Route
                path="/profissionais"
                element={
                  <PrivateRoute allowedProfiles={[PERFIS.ADMINISTRADOR, PERFIS.AGENDAMENTO]}>
                    <CadastroProfissionais />
                  </PrivateRoute>
                }
              />
              <Route
                path="/profissionais/:id"
                element={
                  <PrivateRoute allowedProfiles={[PERFIS.ADMINISTRADOR, PERFIS.AGENDAMENTO]}>
                    <CadastroProfissionais />
                  </PrivateRoute>
                }
              />
              <Route
                path="/lista-profissionais"
                element={
                  <PrivateRoute allowedProfiles={[PERFIS.ADMINISTRADOR, PERFIS.AGENDAMENTO]}>
                    <ListarProfissionais />
                  </PrivateRoute>
                }
              />
              <Route
                path="/pacientes"
                element={
                  <PrivateRoute allowedProfiles={[PERFIS.ADMINISTRADOR, PERFIS.AGENDAMENTO]}>
                    <CadastroPacientes />
                  </PrivateRoute>
                }
              />
              <Route
                path="/pacientes/:id"
                element={
                  <PrivateRoute allowedProfiles={[PERFIS.ADMINISTRADOR, PERFIS.AGENDAMENTO]}>
                    <CadastroPacientes />
                  </PrivateRoute>
                }
              />
              <Route
                path="/lista-pacientes"
                element={
                  <PrivateRoute allowedProfiles={[PERFIS.ADMINISTRADOR, PERFIS.AGENDAMENTO]}>
                    <ListarPacientes />
                  </PrivateRoute>
                }
              />
              <Route
                path="/meus-horarios"
                element={
                  <PrivateRoute allowedProfiles={[PERFIS.ADMINISTRADOR, PERFIS.PROFISSIONAL]}>
                    <MinhaAgenda />
                  </PrivateRoute>
                }
              />
              <Route
                path="/agenda"
                element={
                  <PrivateRoute allowedProfiles={[PERFIS.ADMINISTRADOR, PERFIS.PROFISSIONAL, PERFIS.AGENDAMENTO]}>
                    <Agendamento />
                  </PrivateRoute>
                }
              />
              <Route
                path="/profissional-agenda"
                element={
                  <PrivateRoute allowedProfiles={[PERFIS.ADMINISTRADOR, PERFIS.AGENDAMENTO]}>
                    <ProfissionalAgenda />
                  </PrivateRoute>
                }
              />
              <Route
                path="/fechamento"
                element={
                  <PrivateRoute allowedProfiles={[PERFIS.ADMINISTRADOR, PERFIS.PROFISSIONAL]}>
                    <Fechamento />
                  </PrivateRoute>
                }
              />
              <Route
                path="/lista-usuarios"
                element={
                  <PrivateRoute allowedProfiles={[PERFIS.ADMINISTRADOR]}>
                    <ListarUsuarios />
                  </PrivateRoute>
                }
              />
              <Route
                path="/usuarios"
                element={
                  <PrivateRoute allowedProfiles={[PERFIS.ADMINISTRADOR]}>
                    <CadastrarUsuario />
                  </PrivateRoute>
                }
              />
               <Route
                path="/usuarios/:id"
                element={
                  <PrivateRoute allowedProfiles={[PERFIS.ADMINISTRADOR]}>
                    <CadastrarUsuario />
                  </PrivateRoute>
                }
              />
              <Route
                path="/lista-servicos"
                element={
                  <PrivateRoute allowedProfiles={[PERFIS.ADMINISTRADOR]}>
                    <ListarServicos />
                  </PrivateRoute>
                }
              />
              <Route
                path="/servicos"
                element={
                  <PrivateRoute allowedProfiles={[PERFIS.ADMINISTRADOR]}>
                    <CadastrarServico />
                  </PrivateRoute>
                }
              />
               <Route
                path="/servicos/:id"
                element={
                  <PrivateRoute allowedProfiles={[PERFIS.ADMINISTRADOR]}>
                    <CadastrarServico />
                  </PrivateRoute>
                }
              />
               <Route
                path="/configuracao-servicos"
                element={
                  <PrivateRoute allowedProfiles={[PERFIS.ADMINISTRADOR]}>
                    <ConfiguracaoServicos />
                  </PrivateRoute>
                }
              />
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </Layout>
        </Router>
      </NotificationProvider>
    </AuthProvider>
  );
};

export default App;
